module.exports = __webpack_public_path__ + "media/images/post-ad1d4ba32aee86acc803fc186ca7013e.svg";